import Repository from "@/apis/Repository.js";

const GET_ALL = "";
const GETPAGEBYTAGS = "getpagebytags";
const EDIT_PAGE = "";
const BULK_EDIT = "bulkEdit";
const GETPAGEBYCATEGORY = "getpagebycategory";
const GETPAGEBYCATEGORYFORBLOG = "getpagebycategoryforblog";
const GETPAGEBYCATEGORYFOREVENT = "GetPagesbyCategoryForEvent";
const SH_VIEWERS = "selfHelpViewer";
export default {
  getPages() {
    return Repository.get(transformRoute(GET_ALL));
  },

  getpagebycategory(payload) {
    return Repository.post(transformRoute(GETPAGEBYCATEGORY), payload);
  },

  getPagesbyCategoryForBlog(payload) {
    return Repository.post(transformRoute(GETPAGEBYCATEGORYFORBLOG), payload);
  },

  getPagesbyCategoryForEvent(payload) {
    return Repository.post(transformRoute(GETPAGEBYCATEGORYFOREVENT), payload);
  },

  getPageByTags(payload) {
    return Repository.post(transformRoute(GETPAGEBYTAGS), payload);
  },

  getSinglePage(payload) {
    return Repository.get(transformRoute(payload));
  },

  addPage(payload) {
    return Repository.post(transformRoute(GET_ALL), payload);
  },

  deletePage(payload) {
    return Repository.delete(transformRoute(payload));
  },
  editPage(payload) {
    return Repository.patch(transformRoute(EDIT_PAGE), payload);
  },
  bulkEdit(payload) {
    return Repository.post(transformRoute(BULK_EDIT), payload)
  },
  selfHelpViewers(payload) {
    return Repository.post(transformRoute(SH_VIEWERS), payload);
  },
};

const transformRoute = (route = "") => {
  return `/cms/page/${route}`;
};
